import { render, staticRenderFns } from "./TestModal.vue?vue&type=template&id=c59e708a&scoped=true"
import script from "./TestModal.vue?vue&type=script&lang=js"
export * from "./TestModal.vue?vue&type=script&lang=js"
import style0 from "./TestModal.vue?vue&type=style&index=0&id=c59e708a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59e708a",
  null
  
)

export default component.exports